/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Timing_LabelInputs */

const en_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing`)
};

const fr_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutage`)
};

const de_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing`)
};

const it_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempistica`)
};

const ru_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время`)
};

const es_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momento`)
};

const zh_cn2_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定时`)
};

const ja_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミング`)
};

const hi_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय`)
};

const pt_pt2_error_nav_timing_label = /** @type {(inputs: Error_Nav_Timing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo`)
};

/**
* | output |
* | --- |
* | "Timing" |
*
* @param {Error_Nav_Timing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_timing_label = /** @type {((inputs?: Error_Nav_Timing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Timing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_timing_label(inputs)
	if (locale === "de") return de_error_nav_timing_label(inputs)
	if (locale === "it") return it_error_nav_timing_label(inputs)
	if (locale === "ru") return ru_error_nav_timing_label(inputs)
	if (locale === "es") return es_error_nav_timing_label(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_timing_label(inputs)
	if (locale === "ja") return ja_error_nav_timing_label(inputs)
	if (locale === "hi") return hi_error_nav_timing_label(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_timing_label(inputs)
	return en_error_nav_timing_label(inputs)
});